import { useEffect, useState } from 'react';
import { Copy } from '@globalvisioninc/assets/icons';
import { TooltipButton } from '@globalvisioninc/ui/tooltip-button';

export const CopyButton = ({ text, label, isDisabled }: { text: string; label: string; isDisabled?: boolean }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const dismiss = () => {
      setIsOpen(false);
    };

    const timeoutId = window.setTimeout(() => {
      document.addEventListener('click', dismiss);
    }, 0);

    return () => {
      window.clearTimeout(timeoutId);
      document.removeEventListener('click', dismiss);
    };
  }, [isOpen]);

  return (
    <TooltipButton.Root
      type="button"
      tooltip={`${label} copied`}
      aria-label={`Copy ${label}`}
      tooltipSide="top"
      tooltipDelayDuration={0}
      hasArrow={false}
      isOpen={isOpen}
      isDisabled={isDisabled}
      onClick={() => {
        navigator.clipboard.writeText(text);
        setIsOpen(true);
      }}
    >
      <Copy />
    </TooltipButton.Root>
  );
};
